export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.11.0',
};
//# sourceMappingURL=buildEnv.js.map